export const MIN_INTRO_DESCRIPTION_CHARS = 4;
export const MAX_INTRO_TITLE_CHARS = 90;
export const MAX_INTRO_DESCRIPTION_CHARS = 350;
